<template>
  <div class="home-page">
    <!-- Top Navigation Bar -->
    <div class="top-bar">
      <div class="nav-container">
        <!-- Logo/Brand -->
        <div class="brand" :class="{ 'hide-on-search': searchActive }">
        <div
          @click="$refs.ongoingLive.show()"
          class="brand-icon"
          :class="{ 'brand-icon--online': $refs.ongoingLive?.requests?.length }"
        >
          <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="white"/>
            <circle cx="12" cy="12" r="5.25" fill="white"/>
          </svg>
          <span v-if="$refs.ongoingLive?.requests?.length" class="brand-icon__dot"></span>
          <span v-if="$refs.ongoingLive?.newNotifications?.length" class="brand-icon__number">
            {{ $refs.ongoingLive.newNotifications.length > 99 ? 99 : $refs.ongoingLive.newNotifications.length }}
          </span>
        </div>
      </div>

        <!-- Navigation Tabs -->
        <div class="nav-tabs" :class="{ 'hide-on-search': searchActive }">
          <button
            :class="['nav-tab', { active: activeTab === 'publication' }]"
            @click="activeTab = 'publication'"
          >
            Publication
          </button>

          <button
            :class="['nav-tab', { active: activeTab === 'conference' }]"
            @click="activeTab = 'conference'"
          >
            Conference
            <span class="live-indicator"></span>
          </button>

          <button
            :class="['nav-tab', { active: activeTab === 'people' }]"
            @click="activeTab = 'people'"
          >
            People
          </button>
        </div>

        <!-- Search Icon / Input -->
        <div class="search-wrapper">
          <div v-if="searchActive" class="search-input-container">
            <input
              ref="searchInput"
              v-model="searchQuery"
              @keyup="handleSearchKeyup"
              type="text"
              class="search-input"
              :placeholder="'Search '+activeTab"
            />
            <button @click="handleSearch" class="search-submit-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
            </button>
          </div>
          <button 
            @click="toggleSearch" 
            class="search-btn"
            :class="{ active: searchActive }"
          >
            <svg v-if="!searchActive" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Status Preview Zone -->
    <div class="status-zone" v-show="activeTab === 'people'">
      <div  v-show="statusZoneVisible" class="status-container">
        <button class="scroll-btn scroll-left" @click="scrollLeft" v-show="canScrollLeft">
          <svg style="min-width: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>

        <div class="status-scroll" ref="statusScroll" @scroll="checkScroll">
          <!-- Add Your Status -->
          <div class="status-item my-status">
            <div class="status-card">
              <div class="status-image" :style="{ 
                       background: !myStatus.imgMini? colors[myStatus.wallpaper || 0]:`url(${bsUrl+myStatus.imgMini}) no-repeat center / cover`
                    }">
              </div>
              <div class="status-overlay" >
                <div v-if="!myStatus.img&&!myStatus.audio" class="status-text-preview"><span>{{ myStatus.text }} </span></div>
                <div v-if="myStatus.audio&&!myStatus.img" class="status-text-preview"><svg fill="white" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1,16V8A1,1,0,0,1,3,8v8a1,1,0,0,1-2,0Zm7,4V4A1,1,0,0,0,6,4V20a1,1,0,0,0,2,0Zm5,2V2a1,1,0,0,0-2,0V22a1,1,0,0,0,2,0Zm5-2V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0ZM22,7a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V8A1,1,0,0,0,22,7Z"/></svg></div>
                <div v-if="myStatus.img" class="status-text-preview"></div>
                
                <div class="status-text">My status </div>
              </div>
              <div @click.stop="$refs.statusViewer.show([myStatus],0)" class="add-status-bg">
                <div @click.stop="$refs.statusForm.show()" class="add-icon">+</div>
              </div>
            </div>
          </div>

          <!-- Friend Status Items -->
          <div 
            v-for="(status, index ) in statuses" 
            :key="status._id"
            class="status-item"
            @click.stop="$refs.statusViewer.show(statuses,index)"
          >
            <div class="status-card">
              <div class="status-image" :style="{ 
                       background: !status.imgMini? colors[status.wallpaper || 0]:`url(${bsUrl+status.imgMini}) no-repeat center / cover`
                    }"
               >
                <div class="status-avatar" :class="{ 'has-new': status.hasNew }">
                  <img :src="!status.avatar ? require('./img/profile.svg') : bsUrl+status.avatar" :alt="status.name" />
                </div>
              </div>
              <div class="status-overlay">
                <div v-if="!status.img&&!status.audio" class="status-text-preview"><span>{{ status.text }} </span></div>
                <div v-if="status.audio&&!status.img" class="status-text-preview"><svg fill="white" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1,16V8A1,1,0,0,1,3,8v8a1,1,0,0,1-2,0Zm7,4V4A1,1,0,0,0,6,4V20a1,1,0,0,0,2,0Zm5,2V2a1,1,0,0,0-2,0V22a1,1,0,0,0,2,0Zm5-2V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0ZM22,7a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V8A1,1,0,0,0,22,7Z"/></svg></div>
                <div v-if="status.img" class="status-text-preview"></div>
                <div class="status-name-overlay">{{ status.name }}</div>
              </div>
            </div>
          </div>

        </div>

        <button class="scroll-btn scroll-right" @click="scrollRight" v-show="canScrollRight">
          <svg style="min-width: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button>
      </div>
      <button class="toggle-fab" :class="{ 'toggle-fab--open': !statusZoneVisible }" @click="statusZoneVisible = !statusZoneVisible">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15"/>
        </svg>
      </button>
    </div>

    <!-- Main Content Area -->
    <PeopleList ref="peopleList" v-show="activeTab === 'people'" style="padding-top: 20px;" class="content-area"/>
    <Publications ref="publications" v-show="activeTab === 'publication'"  v-if="$store.state.user?.uid" class="content-area"/>
    <Conferences ref="conferences" v-show="activeTab === 'conference'" class="content-area"/>
<!--     <div v-if="activeTab !== 'people' && activeTab !== 'publication'" class="main-content">
      <div class="content-placeholder">
        <div class="placeholder-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
          </svg>
        </div>
        <h3>Nothing found </h3>
        <p>Your feed will appear here. Sorry we found nothing, may be there is an internet connection issue or try to find something else.</p>
      </div>
    </div>  -->
    <StatusForm ref="statusForm" @statusCreated="init"/>
    <StatusViewer ref="statusViewer" @closed="init" />
    <OngoingLive ref="ongoingLive" @goToPeople="()=> activeTab = 'people'" />
  </div>
</template>

<script>
import PeopleList from '@/views/components/peopleList/PeopleList.vue';
import StatusForm from '@/views/components/statusForm/StatusForm.vue';
import StatusViewer from '@/views/status/Status.vue';
import Publications from '@/views/publications/Publications.vue';
import Conferences from '@/views/conference/Conferences.vue';
import OngoingLive from './OngoingLive.vue';
import { initPush } from '@/plugin/pushNotifications'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app' // for battery consomption improvment

export default {
  name: 'HomePage',
  components: {
    PeopleList,
    StatusForm,
    StatusViewer,
    Publications,
    Conferences,
    OngoingLive
  },
  data() {
    return {
      activeTab: 'publication',
      statusZoneVisible:true,
      colors: this.$store.state.colors,
      bsUrl: this.$store.state.baseUrl + 'images/',
      canScrollLeft: false,
      canScrollRight: true,
      statusPage: 0,
      allStatusesLoaded: false,
      searchActive: false,
      searchQuery: '',
      myStatus:{},
      statuses: [],
      allStatuses:[]
    }
  },
  methods: {
    toggleSearch() {
      this.searchActive = !this.searchActive;
      if (this.searchActive) {
        this.$nextTick(() => {
          this.$refs.searchInput?.focus();
        });
      } else {
        this.searchQuery = '';
      }
    },
    handleSearch() {
      if (this.searchQuery.trim()) {
        if(this.activeTab == 'people') this.$refs.peopleList.searchUser(this.searchQuery.trim())
        else if(this.activeTab == 'publication') this.$refs.publications.search(this.searchQuery.trim())
        else if(this.activeTab == 'conference') this.$refs.conferences.search(this.searchQuery.trim())
      }
    },
    handleSearchKeyup(event) {
      if (event.key === 'Enter') {
        this.handleSearch();
      } else if (event.key === 'Escape') {
        this.searchActive = false;
        this.searchQuery = '';
      }
    },
    scrollLeft() {
      this.$refs.statusScroll.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    },
    scrollRight() {
      this.$refs.statusScroll.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    },
    checkScroll() {
      const el = this.$refs.statusScroll;
      if (el) {
        this.canScrollLeft = el.scrollLeft > 0;
        this.canScrollRight = el.scrollLeft < (el.scrollWidth - el.clientWidth - 10);
      }
      if (this.canScrollRight === false && !this.allStatusesLoaded) {
        this.loadMoreStatuses()
      }
    },
    loadMoreStatuses () {
      this.statusPage++
      const next = this.allStatuses.slice(this.statusPage * 10, (this.statusPage + 1) * 10)
      if (next.length === 0) { this.allStatusesLoaded = true; return }
      this.statuses = [...this.statuses, ...next]
      if ((this.statusPage + 1) * 10 >= this.allStatuses.length) {
        this.allStatusesLoaded = true
      }
    },
    init () {
      this.myStatus = {} // reseting
      const allStatus = this.$store.state.status
      const allUsers = this.$store.state.users
      let statuses = []
      for(const key in allStatus) {
        if(key === this.$store.state.user.uid) continue
        const currStatuses = allStatus[key]
        const latestStatus = currStatuses[currStatuses.length - 1]
        const hasNew = latestStatus.vue?.find(vu => vu.userId === this.$store.state.user.uid)
        const user = allUsers[key]
        /* console.log("keyyy",key)
        console.log("userrrr",user) */
        statuses.push({uid:user.uid,name:user.pseudo,
        avatar:user.profilImgMini1,hasNew:!hasNew,...latestStatus})
      }
/*       statuses = statuses.concat(statuses)
      statuses = statuses.concat(statuses)
      statuses = statuses.concat(statuses)
      statuses = statuses.concat(statuses)
      statuses = statuses.concat(statuses) */

      this.allStatuses = statuses  // keep the full array privately
      this.statusPage = 0
      this.allStatusesLoaded = false
      this.statuses = statuses.slice(0, 10)

      const user = this.$store.state.user
      const myStatuses = allStatus[user.uid]
      if(myStatuses?.length > 0) this.myStatus = {uid:user.uid,name:user.pseudo,avatar:user.profilImgMini1,...myStatuses.at(-1)} || {}
    },
    async isAppInBackground() {
        // Check WebView visibility
        const isDocumentHidden = document.hidden

        // Check native Capacitor app state
        const { isActive } = await App.getState()

        // Consider the app in the background if either check indicates it
        return isDocumentHidden || !isActive
    },
    async getStatus (loading=true) {
      this.loading = loading
      try {
          const inBackground = await this.isAppInBackground()
          if(inBackground) return 
          
          const res = await this.$axios.post('status.php',{type:"statusList"})
          const res1 = await this.$axios.post('status.php',{type:"allFriendStatus"})
          const myStatus = res.data || []

          this.$store.commit('setUserStatuses',{uid:this.$store.state.user.uid,statuses:myStatus})
          const friendsStatus = res1.data || []
          const k = this
          let friendsId = []
          friendsStatus.forEach(fs => {
            k.$store.commit('setUserStatuses',{uid:fs.uid,statuses:fs.status})
            friendsId.push(fs.uid)
          });
          const likersIds = []
          myStatus.likes?.forEach(vu=> {
            likersIds.push(vu.userId)
          })
          friendsStatus.forEach(st=>{
            st.likes?.forEach(vu=> {
              likersIds.push(vu.userId)
            })
          })
          const usersToGet = likersIds.concat(friendsId)
          if(usersToGet.length > 0) {
            const res2 = await this.$axios.post('user.php',{type:"getUsersMetaData",users:usersToGet})
            const users = res2.data || []
            users.forEach(us => {
              k.$store.commit('setAnUser',us)
            })
          }
          this.init()
      } catch (e) {
          console.log(e.response?.data?.error || e.message);
      } finally { 
        this.loading = false 
        
        setTimeout(this.getStatus,60000)
      }
    },
    close () {
      if(this.$store.state.publicationFormVisible) {
        this.$store.commit('setPublicationFormVisibility',false)
        return false
      }
      if(this.$refs.ongoingLive.open) {
          this.$refs.ongoingLive.close()
          return false
      } 
      if(this.activeTab == 'publication') return this.$refs.publications.close()
      else if(this.activeTab == 'conference') return this.$refs.conferences.close()
      else {
        if(this.$refs.statusViewer.Display){
          this.$refs.statusViewer.close()
          return false
        }
        if(this.$refs.statusForm.Display){
          this.$refs.statusForm.close()
          return false
        }
        return this.$refs.peopleList.close()
      }
    },
    async initNotification () {
      if (Capacitor.getPlatform() !== 'android') return;
      await PushNotifications.createChannel({
        id: 'social_notifications',
        name: 'Social notifications',
        importance: 4, // high
        visibility: 1,
        sound: 'default',
      })

      initPush(
        async (token) => {
          await this.$axios.post('/notification.php', { type: 'registerToken', token })
          //alert(token)
          localStorage.setItem('pushToken', token)
        },
        (data) => {
          //alert(JSON.stringify(data))
          // route based on the payload sent from the backend
          if(data.type === 'conf') this.$router.push('/conference/'+data.targetId)
          if(data.type === 'message') this.$router.push('/inbox')

          if(data.type === 'pub') this.$router.push('/publication/'+data.targetId)
          if(data.type === 'follow') this.$router.push('/profile/'+data.targetId)
          if(data.type === 'status') this.activeTab = 'people'
        }
      )
    }
  },
  async mounted() {
    this._statusResizeObserver = new ResizeObserver(() => { this.checkScroll() })
    this.$nextTick(() => {
      if (this.$refs.statusScroll) {
        this._statusResizeObserver.observe(this.$refs.statusScroll)
      }
    })


    let conf = this.$store.state.currentConference
    if(conf) {
      this.activeTab = 'conference'
      this.$refs.conferences.show(conf)
      this.$store.commit('setCurrentConference',null)
    }

    this.getStatus()
    
    // ------------- pushNotfication handling ------------------------
    this.initNotification()

  },
  watch: {
    '$store.state.currentConference' ( conf ) { // load pub from link
      if(conf) {
        this.activeTab = 'conference'
        this.$refs.conferences.openLive(conf)
        this.$store.commit('setCurrentConference',null)
      }
    }
  },
  beforeUnmount () {
    if (this._statusResizeObserver) this._statusResizeObserver.disconnect()
  },
}
</script>

<style scoped>
.home-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow: hidden; /* clips the sliding feed-track inside Publications */
  display: flex;
  flex-direction: column;
  background: #0a0e26;
  /* background: #0a0e1a; */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* KEY: content-area fills all remaining space after top-bar */
.content-area {
  padding-top: 60px;
  flex: 1;
  min-height: 0; /* required for flex children to shrink below content size */
}

/* Top Navigation Bar */
.top-bar {
  position: absolute;
  width: 100%;
  z-index: 50;
  background: rgba(10, 14, 38, 0.5);
  /* border-bottom: 1px solid rgba(0, 212, 255, 0.15); */
  flex-shrink: 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 12px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: auto;
}


.brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 10px;
}

.brand-icon {
  position: relative;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #00d4ff, #8338ec);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.brand-icon > svg {
  width: 27px;
  height: 27px;
}

/* ---- Online / ongoing-live state ---- */
.brand-icon--online {
  animation: brand-icon-glow 1.8s ease-in-out infinite;
}

@keyframes brand-icon-glow {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.55);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(0, 212, 255, 0);
  }
}

.brand-icon__number {
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #fb3d68;
  color:white;
  font-size: 12px;
  display: flex;justify-content: center;align-items: center;
}
.brand-icon__dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #fb3d68;
  border: 2px solid #0a0e1a;
  /* animation: brand-icon-dot-pulse 1.6s infinite; */
}

/* @keyframes brand-icon-dot-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 61, 104, 0.6);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(251, 61, 104, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 61, 104, 0);
  }
} */



.nav-tabs {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
}
.nav-tabs > * + * {
  margin-left: 24px;
}

.nav-tab {
  position: relative;
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 15px;
  font-weight: 600;
  padding: 18px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.nav-tab > span {
  margin-left: 6px;
}

.nav-tab:hover {
  color: #e0f7ff;
}

.nav-tab.active {
  color: #e0f7ff;
}

.nav-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #00d4ff, #8338ec);
}

.live-indicator {
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
  animation: pulse 2s infinite;
  margin-left: 6px;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(1.1); }
}

.search-wrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.search-wrapper > * + * {
  margin-left: 10px;
}

.search-input-container {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  padding: 0 8px;
  overflow: hidden;
}

.search-input {
  background: transparent;
  border: none;
  outline: none;
  color: #e0f7ff;
  font-size: 14px;
  padding: 10px 8px;
  width: 200px;
  font-family: inherit;
}

.search-input::placeholder {
  color: #94a3b8;
}

.search-submit-btn {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #00d4ff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.search-submit-btn:hover {
  background: rgba(0, 212, 255, 0.1);
}

.search-submit-btn svg {
  width: 18px;
  height: 18px;
}

.search-btn {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #94a3b8;
  border-radius: 8px;
  flex-shrink: 0;
}

.search-btn:hover,
.search-btn.active {
  background: rgba(30, 41, 59, 0.5);
  color: #e0f7ff;
}

.search-btn svg {
  width: 22px;
  height: 22px;
}

@media (max-width: 900px) {
  .hide-on-search {
    display: none !important;
  }
  .search-input-container {
    width: auto;
  }
  .search-input {
    width: calc(100vw - 120px);
    max-width: 400px;
  }
}

/* Status Preview Zone */
.status-zone {
  position: relative;
  margin-top: 60px;
  background: rgba(15, 23, 42, 0.6);
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  padding: 12px 0;
  flex-shrink: 0;
}

.status-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 12px;
}

.scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  background: rgba(10, 14, 38, 0.95);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  color: #00d4ff;
}

.scroll-btn:hover {
  background: rgba(10, 14, 38, 1);
  border-color: rgba(0, 212, 255, 0.6);
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

.scroll-btn svg {
  width: 18px;
  height: 18px;
}

.scroll-left { left: 8px; }
.scroll-right { right: 8px; }

.status-scroll {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 4px 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.status-scroll > * + * { margin-left: 12px; }
.status-scroll::-webkit-scrollbar { display: none; }

.status-item {
  flex-shrink: 0;
  cursor: pointer;
}
.toggle-fab {
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin-right: 10px;
  margin-bottom: -17px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgba(10, 14, 38, 0.9);
  border: 1px solid rgba(0, 212, 255, 0.3);
  color: #00d4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.toggle-fab svg {
  width: 20px;
  height: 20px;
}

.toggle-fab:hover {
  background: rgba(0, 212, 255, 0.15);
  border-color: rgba(0, 212, 255, 0.5);
}

.toggle-fab--open svg {
  transform: rotate(180deg);
}


.status-card {
  position: relative;
  width: 120px;
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
}

.status-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.add-status-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-icon {
  width: 40px;
  height: 40px;
  background: rgba(10, 14, 38, 0.8);
  border: 2px solid #e0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #e0f7ff;
  font-weight: 300;
}

.status-avatar {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 2.5px solid rgba(30, 41, 59, 0.8);
  overflow: hidden;
  background: #1e293b;
}

.status-avatar.has-new {
  border-color: #22c55e;
  box-shadow: 0 0 15px rgba(34, 197, 94, 0.5);
}

.status-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to top, rgba(10, 14, 38, 0.95), transparent);
  padding: 40px 12px 12px;
}

.status-text-preview {
  font-weight: normal;
  color: white;
  font-size: 13px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-text-preview > span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-text-preview > svg {
  width: 40px;
  height: 40px;
}

.status-text {
  color: #e0f7ff;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  color: #94a3b8;
}

.status-name-overlay {
  color: #e0f7ff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

/* Main Content fallback */
.main-content {
  flex: 1;
  min-height: 0;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.content-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 20px;
}

.placeholder-icon {
  width: 80px;
  height: 80px;
  background: rgba(0, 212, 255, 0.1);
  border: 2px solid rgba(0, 212, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: #00d4ff;
}

.placeholder-icon svg {
  width: 36px;
  height: 36px;
}

.content-placeholder h3 {
  color: #e0f7ff;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 12px 0;
}

.content-placeholder p {
  color: #94a3b8;
  font-size: 15px;
  max-width: 500px;
  line-height: 1.6;
  margin: 0;
}


@media (max-width: 340px) {
  .nav-tabs > * + * { margin-left: 14px; }
  .nav-tab { font-size: 13px; }
  .search-btn { padding: 6px; }
  .search-btn svg { width: 20px; height: 20px; }
}
</style>